import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STORAGE_KEY = "tsg_sid";

function getOrCreateSessionId() {
    try {
        let sid = window.localStorage.getItem(STORAGE_KEY);
        if (!sid) {
            sid =
                (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
                `${Date.now()}-${Math.random().toString(36).slice(2)}`;
            window.localStorage.setItem(STORAGE_KEY, sid);
        }
        return sid;
    } catch {
        // Fall back if localStorage is unavailable (private mode, etc.)
        return `tx-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    }
}

// Anonymous pageview tracker. Fires on every route change.
export default function useAnalytics() {
    const location = useLocation();
    const lastPath = useRef(null);

    useEffect(() => {
        if (lastPath.current === location.pathname) return;
        lastPath.current = location.pathname;
        const sid = getOrCreateSessionId();
        axios
            .post(`${API}/analytics/track`, {
                session_id: sid,
                path: location.pathname,
                referrer: document.referrer || null,
            })
            .catch(() => {
                // Analytics must never break the site — silently swallow.
            });
    }, [location.pathname]);
}
